import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AiReadButton, AiProfiloFields } from "@/components/AiProfilo";

const init = (p) => ({ website: p.website || "", descrizione: p.descrizione || "", topics: p.topics || [], fondatore: p.fondatore || "", anno_fondazione: p.anno_fondazione || "", valori: p.valori || [] });

export function AiProfiloCrm({ p, onSaved }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try { await api.put(`/partners/${p.id}/ai-profilo`, f); toast.success("Profilo salvato"); setOpen(false); onSaved?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Salvataggio non riuscito"); }
    setSaving(false);
  };
  return (
    <>
      <Button size="sm" variant="outline" onClick={() => { setF(init(p)); setOpen(true); }} data-testid="crm-ai-profilo-open"><Sparkles className="mr-1.5 h-4 w-4" />Profilo con AI</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[88vh] max-w-2xl overflow-y-auto" data-testid="crm-ai-profilo-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Sparkles className="h-5 w-5 text-primary" />Profilo installatore con AI</DialogTitle>
            <DialogDescription>Legge il sito web e scrive biografia, valori e topic. Controlla e salva: il Partner lo vede in Ai VESTA.</DialogDescription>
          </DialogHeader>
          {f && (
            <div className="space-y-4">
              <div>
                <div className="mb-1 text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Sito web</div>
                <input className="w-full rounded-md border border-input bg-background px-3 py-2 text-base sm:text-sm" value={f.website} onChange={(e) => setF({ ...f, website: e.target.value })} placeholder="www…" data-testid="crm-ai-profilo-website" />
                <AiReadButton theme="light" website={f.website} generate={(w) => api.post(`/partners/${p.id}/ai-profilo`, { website: w }, { timeout: 120000 }).then((r) => r.data)}
                  onResult={(r) => setF((o) => ({ ...o, descrizione: r.descrizione, topics: r.topics, fondatore: r.fondatore || o.fondatore, anno_fondazione: r.anno_fondazione || o.anno_fondazione, valori: r.valori.length ? r.valori : o.valori }))} />
              </div>
              <div>
                <div className="mb-1 text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Biografia (prima persona)</div>
                <textarea rows={6} className="w-full rounded-md border border-input bg-background px-3 py-2 text-base sm:text-sm" value={f.descrizione} onChange={(e) => setF({ ...f, descrizione: e.target.value })} data-testid="crm-ai-profilo-descrizione" />
              </div>
              <AiProfiloFields theme="light" f={f} setF={setF} />
              <div className="flex justify-end"><Button onClick={save} disabled={saving} data-testid="crm-ai-profilo-save">{saving ? "Salvataggio…" : "Salva profilo"}</Button></div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export function ProfiloExtra({ p, dark }) {
  const chip = dark ? "border-[#C17F59]/50 text-[#E5B89A]" : "border-border text-foreground";
  const muted = dark ? "text-[#9CA3AF]" : "text-muted-foreground";
  if (!p?.fondatore && !p?.anno_fondazione && !p?.valori?.length && !p?.topics?.length) return null;
  return (
    <div className="space-y-2 pt-1" data-testid="profilo-extra">
      {(p.fondatore || p.anno_fondazione) && (
        <div className={`text-xs ${muted}`} data-testid="profilo-extra-fondazione">
          {p.fondatore && <>Fondata da <b className={dark ? "text-white" : "text-foreground"}>{p.fondatore}</b></>}{p.fondatore && p.anno_fondazione && " · "}{p.anno_fondazione && <>dal <b className={dark ? "text-white" : "text-foreground"}>{p.anno_fondazione}</b></>}
        </div>
      )}
      {p.valori?.length > 0 && (
        <ul className="space-y-0.5 text-sm" data-testid="profilo-extra-valori">
          {p.valori.map((v) => <li key={v} className="flex gap-2"><span className={dark ? "text-[#C17F59]" : "text-primary"}>✓</span>{v}</li>)}
        </ul>
      )}
      {p.topics?.length > 0 && (
        <div className="flex flex-wrap gap-1.5" data-testid="profilo-extra-topics">
          {p.topics.map((t) => <span key={t} className={`rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${chip}`}>{t}</span>)}
        </div>
      )}
    </div>
  );
}
